import Cookies from 'universal-cookie'
const cookies = new Cookies()
import { CookieDomain } from './config.js'
let cookieConfig = {}
    //if(CookieDomain !== ''){
cookieConfig = { domain: document.domain } //path:'/',maxAge:365*24*60*60
    //}

export function saveCookie(name, value) {
    cookies.set(name, value, cookieConfig)
}

export function getCookie(name) {
    return cookies.get(name)
}

export function removeCookie(name) {
    cookies.remove(name, cookieConfig)
}

export function signOut() {
    cookies.remove('token', cookieConfig)
}

export function isLogin() {
    return !!cookies.get('token')
}

export function getCookieI18n(name, defaultValue) {
    var language = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
    if (language.indexOf("zh-CN") > -1) {
        return "CN"
    } else {
        return "EN"
    }
}


// WEBPACK FOOTER //
// ./src/util/cookie.js